import React, { useState, memo } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const FAQ_ITEMS: FAQItem[] = [{
  question: '¿El material sirve para distintos niveles cognitivos?',
  answer: 'Sí. Las 23 temáticas cubren atención focalizada, sostenida, alternante y dividida; memoria, coordinación y percepción visual. Elegís las actividades más adecuadas para cada paciente sin necesidad de adaptar nada.'
}, {
  question: '¿Necesito formación específica para usarlo?',
  answer: 'No. Cada actividad tiene instrucciones claras incluidas. El adulto mayor puede seguirlas solo o con tu guía mínima. Funciona independientemente de tu nivel de formación.'
}, {
  question: '¿Puedo imprimirlo para todos mis pacientes?',
  answer: 'Sí. Es un PDF descargable que podés imprimir sin límite y usar con todos tus pacientes, todas las veces que necesites. Un solo pago, uso ilimitado.'
}, {
  question: '¿Tiene respaldo científico para mencionar en un plan de trabajo?',
  answer: 'Sí. Está basado en neuroplasticidad, reserva cognitiva, el modelo de Sohlberg & Mateer y la gimnasia cerebral de Paul Dennison. Podés mencionarlo en cualquier plan de trabajo o informe profesional.'
}, {
  question: '¿Funciona para sesiones individuales y grupales?',
  answer: 'Ambos. Las actividades funcionan en sesiones individuales y en grupos pequeños. Varias temáticas como juegos de agilidad y atención son ideales para dinamizar encuentros grupales.'
}, {
  question: '¿Cómo recibo el kit después de comprar?',
  answer: 'El acceso es inmediato. Tras tu compra recibís un mail con el link de descarga directa. Podés verlo en celular, tablet o computadora, e imprimirlo cuando quieras.'
}, {
  question: '¿Qué pasa si no me sirve?',
  answer: 'Tu compra está protegida. Si en 7 días no estás satisfecho/a, nos mandás un mail y te devolvemos el dinero completo. Sin preguntas.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (idx: number) => {
    setOpenIndex(prev => prev === idx ? null : idx);
  };
  return <div className="divide-y divide-gray-200 border border-gray-200 rounded-xl overflow-hidden" data-id="element-11">
      {FAQ_ITEMS.map((item, idx) => <div key={idx} className="bg-white" data-id="element-12">
          <button onClick={() => toggle(idx)} className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-50 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-inset" style={{
        focusVisibleRingColor: 'var(--color-green-dark)'
      } as React.CSSProperties} aria-expanded={openIndex === idx} data-id="element-13">
            <span className="font-semibold text-gray-900 text-base pr-4" style={{
          fontFamily: 'var(--font-heading)',
          letterSpacing: '0.01em'
        }} data-id="element-14">
              {item.question}
            </span>
            <ChevronDownIcon className="w-5 h-5 flex-shrink-0 text-gray-500 transition-transform duration-300" style={{
          transform: openIndex === idx ? 'rotate(180deg)' : 'rotate(0deg)'
        }} data-id="element-15" />
          </button>
          <div className="overflow-hidden transition-all duration-300 ease-in-out" style={{
        maxHeight: openIndex === idx ? '300px' : '0px'
      }} data-id="element-16">
            <div className="px-6 pb-5 text-gray-700 leading-relaxed" style={{
          fontFamily: 'var(--font-body)'
        }} data-id="element-17">
              {item.answer}
            </div>
          </div>
        </div>)}
    </div>;
}